import { render, staticRenderFns } from "./addPressDifAlarmDialog.vue?vue&type=template&id=1b742bfd&scoped=true"
import script from "./addPressDifAlarmDialog.vue?vue&type=script&lang=js"
export * from "./addPressDifAlarmDialog.vue?vue&type=script&lang=js"
import style0 from "./addPressDifAlarmDialog.vue?vue&type=style&index=0&id=1b742bfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b742bfd",
  null
  
)

export default component.exports